/* SelectInput.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["elementAfter"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ErrorMessage, Field, HelperMessage } from '@atlaskit/form';
import Select from '@atlaskit/select';
import React, { useCallback } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _3 = "._1e0c1ule{display:block}";
const _2 = "._1e0c1o8l{display:inline-block}";
const _ = "._1bsb1rkg{width:var(--_1gljcou)}";
const InputWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      elementAfter
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_1gljcou": ix(__cmplp.width)
      }),
      ref: __cmplr,
      className: ax(["_1bsb1rkg", __cmplp.elementAfter ? "_1e0c1o8l" : "_1e0c1ule", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InputWrapper.displayName = 'InputWrapper';
}
const InputWrapperContainer = _ref2 => {
  let {
    elementAfter,
    children,
    width
  } = _ref2;
  return elementAfter ? /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(InputWrapper, {
      width: width,
      elementAfter: elementAfter,
      children: children
    }), elementAfter]
  }) : /*#__PURE__*/_jsx(InputWrapper, {
    width: width,
    children: children
  });
};
const SelectInput = _ref3 => {
  let {
    defaultValue,
    helperMessage,
    isCompact,
    isMulti,
    isRequired,
    label,
    name,
    onChange: _onChange,
    options,
    placeholder,
    components,
    validate,
    isDisabled,
    testId,
    applyDefaultValidation,
    width,
    elementAfter,
    showErrorWithoutSubmit = false
  } = _ref3;
  const validateWithDefaults = useCallback((arg1, arg2) => {
    if (isRequired) {
      if (!arg1 || Array.isArray(arg1) && arg1.length === 0) {
        return "".concat(label, " cannot be empty");
      }
    }
    return validate === null || validate === void 0 ? void 0 : validate(arg1, arg2);
  }, [isRequired, label, validate]);
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    label: label,
    isRequired: isRequired,
    validate: applyDefaultValidation ? validateWithDefaults : validate,
    defaultValue: defaultValue,
    testId: testId,
    children: _ref4 => {
      let {
        fieldProps,
        meta: {
          error,
          submitFailed
        }
      } = _ref4;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(InputWrapperContainer, {
          width: width,
          elementAfter: elementAfter,
          children: /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, fieldProps), {}, {
            isMulti: isMulti,
            options: options,
            defaultValue: defaultValue,
            placeholder: placeholder,
            components: components,
            spacing: isCompact ? 'compact' : 'default',
            onChange: e => {
              fieldProps.onChange(e);
              _onChange === null || _onChange === void 0 ? void 0 : _onChange(e);
            },
            isDisabled: isDisabled
          }))
        }), error && (showErrorWithoutSubmit || submitFailed) && /*#__PURE__*/_jsx(ErrorMessage, {
          testId: "".concat(name, "-select-error"),
          children: error
        }), helperMessage && /*#__PURE__*/_jsx(HelperMessage, {
          children: helperMessage
        })]
      });
    }
  });
};
export default SelectInput;